/* eslint-disable @typescript-eslint/no-explicit-any */
import { A2S_LOG_ENTRIES, A2S_OBJECT_KEY } from "@/consts/a2s";
import { isMobile } from "react-device-detect";

type LogIdType = (typeof A2S_LOG_ENTRIES)[number][0];

const A2sMap = new Map(A2S_LOG_ENTRIES);

export const sendClickLog = (logid: LogIdType) => {
  if (!window.$h?.a2s?.sendClickLog) {
    return;
  }

  const optionValue = A2sMap.get(logid);
  window.$h.a2s.sendClickLog(
    A2S_OBJECT_KEY,
    JSON.stringify({
      logid,
      option: isMobile ? `${optionValue}_mo` : optionValue,
    }),
  );
};

export const sendContentsLog = (logid: LogIdType) => {
  if (!window.$h?.a2s?.sendContentsLog) {
    return;
  }

  const optionValue = A2sMap.get(logid);
  window.$h.a2s.sendContentsLog(
    A2S_OBJECT_KEY,
    JSON.stringify({
      logid,
      option: isMobile ? `${optionValue}_mo` : optionValue,
    }),
  );
};

export function withLog<T extends (...args: any[]) => void>(logId: LogIdType, fn: T): (...args: Parameters<T>) => void {
  return (...args: Parameters<T>) => {
    sendClickLog(logId);
    fn(...args);
  };
}
